module.exports = __webpack_public_path__ + "static/media/Huis-1-3.f1b000a4.jpg";